"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileCalendarHeader = exports.MobileHeader = void 0;
const react_1 = __importDefault(require("react"));
const airCastingLogoMobile_svg_1 = __importDefault(require("../../../assets/icons/airCastingLogoMobile.svg"));
const backArrowIcon_svg_1 = __importDefault(require("../../../assets/icons/backArrowIcon.svg"));
const hamburgerMobile_svg_1 = __importDefault(require("../../../assets/icons/hamburgerMobile.svg"));
const urls_1 = require("../../../const/urls");
const fixedStreamSlice_1 = require("../../../store/fixedStreamSlice");
const hooks_1 = require("../../../store/hooks");
const mobileStreamSlice_1 = require("../../../store/mobileStreamSlice");
const filters_1 = require("../../../types/filters");
const userStates_1 = require("../../../types/userStates");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const RealtimeMapUpdatesButton_1 = require("../../atoms/RealtimeMapUpdatesButton/RealtimeMapUpdatesButton");
const RefreshMapButton_1 = require("../../atoms/RefreshMapButton/RefreshMapButton");
const ControlPanel_1 = require("../../organisms/Map/ControlPanel/ControlPanel");
const LocationSearch_1 = require("../LocationSearch");
const BackButton_1 = require("./BackButton");
const S = __importStar(require("./Navbar.style"));
const NavList_1 = __importDefault(require("./NavList/NavList"));
const MobileHeader = ({ isTimelapseView, toggleMenuVisibility, navMenuVisible, t, onOpenCookieSettings, }) => {
    const { currentUserSettings, previousUserSettings, revertUserSettingsAndResetIds, sessionType, } = (0, mapParamsHandler_1.useMapParams)();
    const dispatch = (0, hooks_1.useAppDispatch)();
    const fixedSessionTypeSelected = sessionType === filters_1.SessionTypes.FIXED;
    const handleGoingBack = () => {
        revertUserSettingsAndResetIds();
        fixedSessionTypeSelected
            ? dispatch((0, fixedStreamSlice_1.resetFixedStreamState)())
            : dispatch((0, mobileStreamSlice_1.resetMobileStreamState)());
    };
    return (react_1.default.createElement(S.MobileHeaderContainer, null, currentUserSettings === userStates_1.UserSettings.ModalView ? (react_1.default.createElement(S.GoBack, { onClick: () => handleGoingBack(), "aria-label": t("navbar.mapPage") },
        react_1.default.createElement("img", { src: backArrowIcon_svg_1.default, alt: t("navbar.altGoBackIcon"), "aria-label": t("navbar.goBackToSessions") }),
        previousUserSettings === userStates_1.UserSettings.SessionListView
            ? t("navbar.goBackToSessions")
            : t("navbar.goBackToMap"))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(S.MobileMenuContainer, { className: "active-overlay" },
            react_1.default.createElement("a", { href: urls_1.urls.aircasting, "aria-label": t("navbar.sections.aircastingPage") },
                react_1.default.createElement("img", { alt: t("navbar.altLogo"), src: airCastingLogoMobile_svg_1.default })),
            react_1.default.createElement("nav", null,
                react_1.default.createElement(S.MenuButton, { onClick: toggleMenuVisibility },
                    react_1.default.createElement("img", { src: hamburgerMobile_svg_1.default, alt: t("navbar.altMenu"), "aria-label": t("navbar.sections.openMenu") })))),
        react_1.default.createElement(LocationSearch_1.LocationSearch, { isTimelapseView: isTimelapseView }),
        !isTimelapseView && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(RefreshMapButton_1.RefreshMapButton, null),
            react_1.default.createElement(ControlPanel_1.ControlPanel, null),
            react_1.default.createElement(RealtimeMapUpdatesButton_1.RealtimeMapUpdatesButton, null))),
        navMenuVisible && (react_1.default.createElement(NavList_1.default, { t: t, navMenuVisible: navMenuVisible, toggleMenuVisibility: toggleMenuVisibility, onOpenCookieSettings: onOpenCookieSettings }))))));
};
exports.MobileHeader = MobileHeader;
const MobileCalendarHeader = ({ t }) => {
    return (react_1.default.createElement(S.MobileContainer, null,
        react_1.default.createElement(BackButton_1.BackButton, null)));
};
exports.MobileCalendarHeader = MobileCalendarHeader;
